import { Component, OnInit } from '@angular/core';
import { ShippingLine } from '../../../models/shippingLines/shippingLine';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ParameterService } from '../../../services/parameter.service';
import { AlertService } from '../../../services/alert.service';
import { ShippingLineService } from '../../../services/shipping-line.service';
import { TableColumn } from '../../../models/tables/TableColumn';
import { ShippingLineFilter } from '../../../models/shippingLines/shippingLineFilter';
import { PageOption } from '../../../models/common/pageOption';
import { APP_ROUTES } from '../../../contants/APP_ROUTES';
import { ShippingLineColumns } from '../../../contants/columns/columns.shipping.line';
import { CommonService } from '../../../services/common.service';
import { PARAMS } from '../../../contants/PARAMS';

@Component({
	selector: 'app-shipping-line-list',
	templateUrl: './shipping-line-list.component.html',
	styleUrls: ['./shipping-line-list.component.css']
})
export class ShippingLineListComponent implements OnInit {

	pageOption: PageOption<ShippingLineFilter> = new PageOption();
	formPath: string = APP_ROUTES.shippingLineForm;
	shippingLineEditBackup: ShippingLine;

	public shippingLines: ShippingLine[] = [];
	public tableColumns: TableColumn[] = ShippingLineColumns;

	constructor(
		private _shippingLineService: ShippingLineService,
		private _alertService: AlertService,
		private _parameterService: ParameterService,
		private _commonService: CommonService
	) { }

	ngOnInit() {
		this._parameterService.getCachedParameterObject<TableColumn[]>(PARAMS.SHIPPINGLINE_TABLE_DEFAULT_COLUMNS, 3600).subscribe(
			value => {
				if (value.length != undefined) {
					this.tableColumns = value.length == 0 ? this.tableColumns : value;
				}
				else {
					this._alertService.showError('Invalid response from server, will use default column settings instead.')
				}
			}
		);

		this._parameterService.getCachedParameter<number>(PARAMS.SHIPPINGLINE_TABLE_DEFAULT_PAGE_SIZE, 3600).subscribe(
			value => {
				value = Number(value);
				this.pageOption.pageSize = isNaN(value) || value == 0 ? 50 : value;
				this.pageOption.pageNumber = 1;

				this.fetchData();
			}
		);
	}

	fetchData(){
		this._shippingLineService.getShippingLinesList(this.pageOption).subscribe(
			result => {
				if (result.data != undefined) {
					if(this.pageOption.pageTotal <= 0){
						this.pageOption.pageTotal = result.totalPages;
					}

					let startIndex = ((result.pageNumber - 1) * this.pageOption.pageSize);
					this._commonService.insertAt(this.shippingLines, startIndex, result.data);
				}
			}
		);
	}

	onFetchNextData(pageNumber: number){
		this.pageOption.pageNumber = pageNumber;
		this.fetchData();
	}

	onSave(index: number) {
		let shippingLine = this.shippingLines[index];
		if (!this.validateShippingLine(shippingLine)) {
			this._alertService.showError('shippingLine should have a name.')
		}

		if (shippingLine.id == undefined || shippingLine.id == 0) {
			this.createShippingLine(shippingLine);
		}
		else {
			this.updateShippingLine(index, shippingLine);
		}
	}

	onAdd(event) {
		this.shippingLines.push(new ShippingLine());
	}

	onEditBegin(index: number) {
		this.shippingLineEditBackup = this._shippingLineService.copy(this.shippingLines[index]);
	}

	onEditCancel(index: number) {
		if (this.shippingLineEditBackup == null) {
			return;
		}
		this.shippingLines[index] = this.shippingLineEditBackup;
	}

	private createShippingLine(newShippingLine: ShippingLine) {
		this._shippingLineService.addShippingLine(newShippingLine).subscribe(result => {
			if (result.object != undefined) {
				this._alertService.showSuccess('ShippingLine registered.')
				this.shippingLines[this.shippingLines.length - 1] = result.object;
				this.shippingLineEditBackup = null;
			}
			else {
				this.shippingLines[this.shippingLines.length - 1] = new ShippingLine();
				this._alertService.displayErrorResult(result.errorCollection);
			}
		});
	}

	private updateShippingLine(index: number, existingShippingLine: ShippingLine) {
		this._shippingLineService.updateShippingLine(existingShippingLine).subscribe(result => {
			if (result.object == undefined) {
				this.shippingLines[index] = this.shippingLineEditBackup;
				this._alertService.displayErrorResult(result.errorCollection);
			}
			else {
				this._alertService.showSuccess('Shipping Line data updated.');
				this.shippingLineEditBackup = null;
			}
		});
	}

	private validateShippingLine(shippingLine: ShippingLine): boolean {
		let form = new FormGroup({
			name: new FormControl(shippingLine.name, [
				Validators.required,
				Validators.maxLength(50)
			])
		});

		return form.valid;
	}

}



// WEBPACK FOOTER //
// ./src/app/components/shippingLines/shipping-line-list/shipping-line-list.component.ts